<app-navbar></app-navbar>

<section class="premium-3d-list-page py-5">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-10">
                <div class="premium-page-header mb-5 text-center">
                    <h1 class="ultimate-3d-title">নিউজ এবং ইভেন্ট</h1>
                    <div class="premium-header-divider mx-auto mt-3"></div>
                </div>
                
                <ng-container *ngIf="News_event_data != null">
                    <div class="row g-4">
                        <div class="col-md-6" *ngFor="let item of News_event_data">
                            <!-- Premium 3D List Card -->
                            <div class="ultimate-3d-card list-card h-100 d-flex flex-column" [routerLink]="['/news-and-events', item.Id]" style="cursor: pointer;">
                                <div class="card-image-header" style="max-height: 250px;">
                                    <img [src]="item.ShowAttachments && item.ShowAttachments.length > 0 ? item.ShowAttachments[0].FilePath : '/assets/img/school/logo.png'" 
                                         alt="News image" />
                                    <div class="floating-glass-badge list-badge">
                                        <i class="fa-regular fa-calendar-alt me-2"></i> {{ item.CurrentDate | date:'MMM d, yyyy' }}
                                    </div>
                                </div>
                                
                                <div class="card-content-body d-flex flex-column flex-grow-1 p-4">
                                    <h3 class="fw-bold mb-3" style="color: #0f4c3a; font-size: 22px;">{{ item.TitleBn || item.TitleEn }}</h3>
                                    
                                    <p class="text-muted mb-4 flex-grow-1" style="font-size: 15px; line-height: 1.6; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden;">
                                        {{ stripHtml(item.DetailsBn || item.DetailsEn) }}
                                    </p>
                                    
                                    <div class="mt-auto">
                                        <button class="premium-glass-btn">
                                            বিস্তারিত পড়ুন <i class="fa-solid fa-arrow-right ms-2"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</section>
